function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './ImmersiveHeader.module.scss';
import whitelistProps from '../../../utils/whitelistProps';
import styles from './ImmersiveHeader.module.scss';
import ImmersiveHeaderContext from '../ImmersiveHeaderContext/ImmersiveHeaderContext';
var whitelist = whitelistProps();
export default function ImmersiveHeader(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? 800 : _ref$breakpoint,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'dark' : _ref$mode,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? false : _ref$sticky,
    attrs = _objectWithoutProperties(_ref, ["children", "className", "breakpoint", "mode", "sticky"]);
  var additionalAttrs = whitelist(attrs);
  var context = useMemo(function () {
    return {
      breakpoint: breakpoint,
      mode: mode
    };
  }, [breakpoint, mode]);
  var ref = useRef();
  var _useState = useState('112px'),
    _useState2 = _slicedToArray(_useState, 2),
    stickyHeight = _useState2[0],
    setStickyHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    stickyTop = _useState4[0],
    setStickyTop = _useState4[1];
  useEffect(function () {
    document.documentElement.classList.add('wm-immersive-mode');
    return function () {
      document.documentElement.classList.remove('wm-immersive-mode');
    };
  }, []);
  useEffect(function () {
    if (ref && ref.current) {
      setStickyHeight(ref.current.clientHeight + 'px');
    }
  }, [ref, ref.current]);
  var computeSticky = useCallback(function () {
    // Need to handle for Manage Data bar showing above immersive header
    var el = document.querySelector('#header');
    if (!sticky || !el) {
      setStickyTop(0);
    } else {
      setStickyTop("".concat(el.clientHeight, "px"));
    }
  }, [sticky]);
  useEffect(function () {
    // Navbar triggers resize this when rendered
    computeSticky();
    window.addEventListener('resize', computeSticky);
    return function () {
      window.removeEventListener('resize', computeSticky);
    };
  }, [computeSticky]);
  return /*#__PURE__*/React.createElement(ImmersiveHeaderContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t\t\t#banner {\n\t\t\t\t\t\tmin-height: initial !important;\n\t\t\t\t\t}\n\t\t\t\t\t.main-nav {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\n\t\t\t\t\t#wm-banner {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\n\t\t\t\t\t#content {\n\t\t\t\t\t\tmax-width: initial;\n\t\t\t\t\t\tpadding: 0 100px;\n\t\t\t\t\t}\n\t\t\t\t\t@media (max-width: ".concat(breakpoint, "px) {\n\t\t\t\t\t\t#content {\n\t\t\t\t\t\t\tmax-width: initial;\n\t\t\t\t\t\t\tpadding: 0 1em;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t")), /*#__PURE__*/React.createElement("div", {
    className: "".concat(sticky ? styles.sticky : ''),
    style: {
      height: stickyHeight
    }
  }, /*#__PURE__*/React.createElement("header", Object.assign({
    ref: ref,
    className: "".concat(styles.immersiveHeader, " \n\t\t\t\t\t").concat(styles[mode], " \n\t\t\t\t\t").concat(className, " \n\t\t\t\t\t").concat(mode),
    style: {
      top: sticky ? stickyTop : undefined
    }
  }, additionalAttrs), children)));
}